import { put } from 'redux-saga/effects';
import * as actions from '../actions/index';
import axios from 'axios';


export function* tryFetchPostsSaga(action) {
    try {
        const response = yield axios.get('https://0q8y1vgph9.execute-api.us-east-1.amazonaws.com/prod/posts', {
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': 'a7ILYWUgcQn69GcCLCnT9oZ57uPyR6v8HIH8oRLd',
            }
        });
        if (!response.status === 200) {
            yield put(actions.failFetchPosts());
        }
        const posts = response.data;
        let allPosts = posts.data;

        let lastPostId = posts.LastEvaluatedKey;
        let index = posts.data.length;
        while (lastPostId != null) {
            const nextPosts = yield axios.get('https://0q8y1vgph9.execute-api.us-east-1.amazonaws.com/prod/posts?LastEvaluatedKey=' + lastPostId, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'a7ILYWUgcQn69GcCLCnT9oZ57uPyR6v8HIH8oRLd',
                }
            });
            for (let i = 0; i < nextPosts.data.data.length; i++) {
                allPosts[index + i] = nextPosts.data.data[i]
            }
            index = index + nextPosts.data.data.length
            lastPostId = nextPosts.data.LastEvaluatedKey;
        }
        yield put(actions.successFetchPosts(allPosts));
    } catch (error) {
        yield put(actions.failFetchPosts());
    }
}